export function NumberOfRepliesColumn({ rowData }) {
  return <p>{rowData.replies.length}</p>;
}
